import {DomSanitizer} from '@angular/platform-browser';
import {PipeTransform, Pipe, SecurityContext} from '@angular/core';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private readonly sanitized: DomSanitizer) {}
  transform(value) {
    return this.sanitized.sanitize(SecurityContext.HTML, value);
  }
}